module.exports = __webpack_public_path__ + "static/media/nightout.c5e66072.svg";